angular.module('dpw.components')
  .directive('dpwFixedSidebar', ['helpers', function(helpers) {
      var animateSpeed = 200;
      var delayTime = 100;
      return {
        restrict: 'A',
        link: function (scope, element) {
          element.css('position', 'relative');

          $(window).on('scroll', function() {
            helpers.debounce(function animate() {
              var distance = $(window).scrollTop();
              element.animate({top: distance}, animateSpeed);
            }, delayTime);
          });
        }
      };
    }
  ]);